import JobDashboard from './JobDashboard';

const JobDashboardInfo = (options) => ({
  component: JobDashboard(options),
  initializeComponent: (compCfg, configuration, ctx, childCtx) => {
    const mutComp = compCfg;
    // Data declares the schema
    const schemaType = configuration.schemaService.getType('Job');
    if (!mutComp.configuration) {
      mutComp.configuration = {};
    }
    mutComp.configuration.data = {
      type: 'Job',
      properties: configuration.viewService.initalizeDataProperties({}, schemaType),
    };
    const mutChildCtx = childCtx;
    mutChildCtx.type = schemaType;
  },
  getChildConfigurationKeys: () => {
    return ['dashboardComponent', 'detailsComponent'];
  },
});

export default JobDashboardInfo;
